import { render, staticRenderFns } from "./Waveform.vue?vue&type=template&id=0fd707d0&scoped=true&"
import script from "./Waveform.vue?vue&type=script&lang=js&"
export * from "./Waveform.vue?vue&type=script&lang=js&"
import style0 from "./Waveform.vue?vue&type=style&index=0&id=0fd707d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd707d0",
  null
  
)

export default component.exports